import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import { VerbRichTextEditor } from '../../../../../shared/components/formComponents/VerbRichTextEditor';
import RichTextNotesHeader from './RichTextNotesHeader';
import CopyAssetLink from '../../../../components/CopyAssetLink';

class QuizResultsSectionItem extends Component {
    static propTypes = {
        memberReference: PropTypes.string,
        sectionItemId: PropTypes.string,
        assetLinkOptions: PropTypes.array,
        isGlobalSectionItem: PropTypes.bool
    };

    render() {
        const { memberReference, isGlobalSectionItem, sectionItemId } = this.props;
        return (
            <div key={`${memberReference}-${sectionItemId}`} className={'col-12 quizResultsSectionItem'}>
                <div className={'row'}>
                    <div className={'col-7'}>
                        <Field
                            name={memberReference ? `${memberReference}.content.description` : 'content.description'}
                            label={'Description'}
                            placeholder={'Enter a description'}
                            component={VerbRichTextEditor}
                            readOnly={isGlobalSectionItem}
                            rows={3}
                        />
                    </div>
                    <div className={'col-5 mt-4'}>
                        <RichTextNotesHeader />
                        <CopyAssetLink assetLinkOptions={this.props.assetLinkOptions} />
                    </div>
                </div>
            </div>
        );
    }
}

export default QuizResultsSectionItem;
